import PrivateLayout from "@/components/private/PrivateLayout";
import { ADMIN_NAV } from "@/components/private/adminNav";
import { Card } from "@/components/ui/card";
import { trpc } from "@/lib/trpc";
import { FileText, Inbox, UserCog, Users } from "lucide-react";
import { Link } from "wouter";

export default function AdminPanel() {
  const players = trpc.players.listAdmin.useQuery();
  const coaches = trpc.coaches.listAll.useQuery();
  const contacts = trpc.contact.list.useQuery();

  const stats = [
    {
      label: "Jugadores",
      value: players.data?.length ?? 0,
      icon: <Users className="text-[var(--forest)]" size={22} />,
      href: "/admin/jugadores",
    },
    {
      label: "Miembros del equipo",
      value: coaches.data?.length ?? 0,
      icon: <UserCog className="text-[var(--forest)]" size={22} />,
      href: "/admin/equipo",
    },
    {
      label: "Mensajes recibidos",
      value: contacts.data?.length ?? 0,
      icon: <Inbox className="text-[var(--forest)]" size={22} />,
      href: "/admin/contactos",
    },
  ];

  return (
    <PrivateLayout title="Administración" nav={ADMIN_NAV} requireRole="admin">
      <div className="p-6 md:p-12 max-w-6xl">
        <div className="mb-10">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-[var(--forest)]/70 mb-3">
            Panel interno
          </div>
          <h1 className="font-display font-light text-[var(--forest-deep)] leading-[1.05]" style={{ fontSize: "clamp(2rem, 4.5vw, 3rem)" }}>
            Golf Motion Lab
          </h1>
          <p className="mt-3 text-[var(--forest-deep)]/70 max-w-xl">
            Gestiona jugadores, informes, equipo y mensajes entrantes desde un solo lugar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          {stats.map((s) => (
            <Link key={s.href} href={s.href}>
              <Card className="p-6 bg-white border border-[var(--forest-deep)]/10 hover:border-[var(--forest)]/40 transition-colors cursor-pointer">
                <div className="flex items-center gap-4">
                  <div className="h-12 w-12 rounded-xl bg-[var(--forest)]/10 flex items-center justify-center">
                    {s.icon}
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-wider text-[var(--forest-deep)]/60 font-semibold">
                      {s.label}
                    </div>
                    <div className="font-display text-3xl font-medium text-[var(--forest-deep)]">
                      {s.value}
                    </div>
                  </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>

        <Card className="p-8 bg-white border border-[var(--forest-deep)]/10">
          <h2 className="font-display text-xl font-medium text-[var(--forest-deep)] mb-4">
            Acceso rápido
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Link
              href="/admin/jugadores"
              className="flex items-center gap-3 p-4 rounded-lg border border-[var(--forest-deep)]/10 hover:border-[var(--forest)]/40 transition-colors"
            >
              <Users size={18} className="text-[var(--forest)]" />
              <div>
                <div className="font-medium text-[var(--forest-deep)]">Gestionar jugadores</div>
                <div className="text-xs text-[var(--forest-deep)]/60">
                  Crear ficha, registrar informes y publicarlos.
                </div>
              </div>
            </Link>
            <Link
              href="/admin/equipo"
              className="flex items-center gap-3 p-4 rounded-lg border border-[var(--forest-deep)]/10 hover:border-[var(--forest)]/40 transition-colors"
            >
              <UserCog size={18} className="text-[var(--forest)]" />
              <div>
                <div className="font-medium text-[var(--forest-deep)]">Editar equipo</div>
                <div className="text-xs text-[var(--forest-deep)]/60">
                  Añadir fotos y biografías de los profesionales.
                </div>
              </div>
            </Link>
            <Link
              href="/admin/contactos"
              className="flex items-center gap-3 p-4 rounded-lg border border-[var(--forest-deep)]/10 hover:border-[var(--forest)]/40 transition-colors"
            >
              <Inbox size={18} className="text-[var(--forest)]" />
              <div>
                <div className="font-medium text-[var(--forest-deep)]">Revisar mensajes</div>
                <div className="text-xs text-[var(--forest-deep)]/60">
                  Formularios enviados por visitantes.
                </div>
              </div>
            </Link>
            <Link
              href="/informe-muestra"
              className="flex items-center gap-3 p-4 rounded-lg border border-[var(--forest-deep)]/10 hover:border-[var(--forest)]/40 transition-colors"
            >
              <FileText size={18} className="text-[var(--forest)]" />
              <div>
                <div className="font-medium text-[var(--forest-deep)]">Ver informe muestra</div>
                <div className="text-xs text-[var(--forest-deep)]/60">
                  Referencia visual del formato de informe.
                </div>
              </div>
            </Link>
          </div>
        </Card>
      </div>
    </PrivateLayout>
  );
}
